/*var $window = $(window);
    var $el =  $('[data-section-child="shop-the-look"]');
    var el =  $('[data-section-child="shop-the-look"]');
    var $wrapper = $('[data-shop-the-look-inner]');

    var dots = $('.stl__dot--container');
    var products = $('.stl__products');

    var descriptionElem = $('.stl__description-inner');
    if (descriptionElem) {
      var descriptionContent = descriptionElem.html();
    }
  */
$(document).ready(function(){
  $(".stl__dot").click(handleDotSelect);
  /*$(".option-link").click(function(e){
    e.preventDefault();
     var inputId = $(this).parent().parent().parent().find("input").attr("id");
    window.alert(inputId);
    $(this).parent().parent().parent().find("input").prop("checked",true);
    $(this).parent().parent().parent().find("input").trigger("click");
    $(this).find("input").prop("checked",true);
    $(this).find("input").trigger("change");
  });*/
});
function optionClicked(objId){
  var obj = objId;
  obj.parent().trigger("click");
  obj.parent().parent().parent().find("input").prop("checked",true);
  obj.parent().parent().parent().find("input").trigger("change");
  return;
}
function enableClick(){
   $(".radio-btn").click(function(){
    window.alert("Hello");
    /*$(this).find("input").prop("checked",true);
    $(this).find("input").trigger("change");*/
  });
}
function handleDotSelect(){
  var dot = $(this);
  var parentBtn = $(this);
  var num = $(this).data("index");

    $('.stl__dot').each(function () {
      var obj = $(this);
      if(obj.hasClass('stl__dot--active'))
      obj.removeClass('stl__dot--active');
    });
    deactivateAllDots();
    setActiveDot(dot);
    setDotZIndex(dot);
   
    parentBtn.blur();
}
function setActiveDot(dot) {
  dot.addClass('stl__dot--active');
}

function setDotZIndex(dot) {
    var minusIcon = dot.find('.minus');
    if(minusIcon.hasClass("active")){
      minusIcon.css('z-index', '');
      minusIcon.removeClass("active");
      var plusIcon = dot.find('.plus');
      plusIcon.addClass("active");
      deactivateAllDots();
      replaceDescription();
    }else{
      minusIcon.css('z-index', '1');
       minusIcon.addClass("active");
      var plusIcon = dot.find('.plus');
      if(plusIcon.hasClass("active")){
        plusIcon.removeClass("active");
      }
      var num = dot.data("index");
       showProduct(num);
    }
}

function resetDotZIndex(dot) {
   $('.stl__dot--container').find(".plus").each(function(){
      var plusIcon = $(this);
      plusIcon.css('z-index', '');
     if(plusIcon.hasClass("active")){
       plusIcon.removeClass("active");
     }
   });
    $('.stl__dot--container').find(".minus").each(function(){
      var minusIcon = $(this);
      minusIcon.css('z-index', '');
      if(minusIcon.hasClass("active")){
       minusIcon.removeClass("active");
     }
   });
   
}

function deactivateAllDots() {
  $('.stl__dot--container').find(".plus").each(function(){
    var plusIcon = $(this);
    plusIcon.css('z-index', '');
   if(plusIcon.hasClass("active")){
     plusIcon.removeClass("active");
   }
 });
  $('.stl__dot--container').find(".minus").each(function(){
    var minusIcon = $(this);
    minusIcon.css('z-index', '');
    if(minusIcon.hasClass("active")){
     minusIcon.removeClass("active");
   }
 });
}

function showProduct(index) {
  $(".stl__products").each(function(){
    var pindex = $(this).data("index");
    if(pindex == index){
       var productToShow = $(this);
      var pid = productToShow.attr("id");
      var divObj = $("#"+pid);
       $('.stl__description-inner').html(productToShow.html());
      var positionTop = ($("#shop-slider .swiper-slide-active .stl__description-container").offset().top) - 150;
      if($(window).width() <= 768 ){
          $('html, body').animate({
            scrollTop: positionTop
         }, 2000);
      }
    }
  });
}

function replaceDescription() {
  $(".stl__description-inner-default").each(function(){
    var defaultContent = $(this).html();
  $(this).parent().find(".stl__description-inner").html(defaultContent);
  });
  var mobile_content = $("#shop-slider .swiper-slide-active .stl__description-inner-default").html();
  $("#mobile-content").html(mobile_content);
  var mobile_content_new = $("#mobile-content").html();
  $("#mobile-content .hide-mobile").each(function(){
    $(this).removeClass("hide-mobile");
  });
}

 